exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".add_name[data-v-e6286b10]{padding-left:70px}.w325[data-v-e6286b10]{width:325px}.result_radio .el-radio+.el-radio[data-v-e6286b10]{margin-left:10%}.dialog-footer[data-v-e6286b10]{text-align:center}.radio_group[data-v-e6286b10]{width:90%;padding-left:15%;max-height:150px;overflow-y:scroll}.list_radio[data-v-e6286b10]{margin-top:10px;margin-left:10%;width:40%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.form_color[data-v-e6286b10]{color:#6a484d}.rule_star92[data-v-e6286b10]{position:relative;left:-92px}.rule_star123[data-v-e6286b10]{position:relative;left:-123px}.rule_star148[data-v-e6286b10]{position:relative;left:-148px}.rule_star176[data-v-e6286b10]{position:relative;left:-176px}.rule_star204[data-v-e6286b10]{position:relative;left:-204px}.ml_10[data-v-e6286b10]{margin-left:-10px}.ml8[data-v-e6286b10]{margin-left:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-e6286b10","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/info_manage/add_categary_agree/old_brand.vue
// module id = 432
// module chunks = 0